"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _classnames = _interopRequireDefault(require("classnames"));
var _locationDropdown = _interopRequireDefault(require("../components/location-dropdown"));
var _terminalDropdown = _interopRequireDefault(require("../components/terminal-dropdown"));
var _timesDropdown = _interopRequireDefault(require("../components/times-dropdown"));
var _flightInput = _interopRequireDefault(require("../components/flight-lookup/flight-input"));
var _wowcherPromo = _interopRequireDefault(require("../components/wowcherPromo"));
var _searchButton = _interopRequireDefault(require("../components/searchButton"));
var _engineHelper = _interopRequireDefault(require("../components/engineHelper"));
var _dateHelper = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/dateHelper"));
var _tracker = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/tracker"));
var _hiddenInputs = _interopRequireDefault(require("../components/hiddenInputs"));
var _helpers = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/helpers"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ParkingEngine extends _react.default.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    const {
      Location,
      formSettings,
      engineSearchField,
      hiddenLocation,
      dropdowns: {
        locations
      },
      showTerminalsField,
      terminalLink,
      port,
      ArrivalDate,
      DepartDate
    } = props;
    const parkingLocations = port ? locations.port : locations.carParking;
    const defaultLocation = port ? formSettings.defaultPortLocation : formSettings.defaultParkingLocation;
    const location = _engineHelper.default.getInitialLocation(hiddenLocation, Location, parkingLocations, defaultLocation);
    const showTerminalDropdown = showTerminalsField && locations.terminals && !terminalLink || false;
    this.state = {
      hiddenInputs: {},
      ArrivalDate,
      DepartDate,
      location,
      ArrivalTime: formSettings.defaultArrivalTime,
      DepartTime: formSettings.defaultDepartTime,
      terminal: this.canShowTerminal(location, props).terminal,
      savedFlight: '',
      datesTouched: false,
      searchTerm: engineSearchField,
      showFlightModal: false,
      terminalField: this.canShowTerminal(location, props).terminalField,
      flightTime: this.adjustFlightDefaultTime(formSettings.defaultArrivalTime),
      showTerminalDropdown,
      flightSecondChanceModalButtonText: 'No thanks'
    };
    this.externallySetDates = this.externallySetDates.bind(this);
    this.saveTime = this.saveTime.bind(this);
    this.dateFocused = this.dateFocused.bind(this);
    this.changedFlight = this.changedFlight.bind(this);
    this.showTerminalField = this.showTerminalField.bind(this);
    this.formSubmit = this.formSubmit.bind(this);
    this.locationSelected = this.locationSelected.bind(this);
    this.terminalSelect = this.terminalSelect.bind(this);
    this.flightFieldInteraction = this.flightFieldInteraction.bind(this);
    this.forceEngineSubmit = this.forceEngineSubmit.bind(this);
    this.changedFlightFromModal = this.changedFlightFromModal.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (_engineHelper.default.checkUpdated(nextState.hiddenInputs, this.state.hiddenInputs)) return true;
    if (_engineHelper.default.checkUpdated(nextState.location, this.state.location)) return true;
    if (_engineHelper.default.checkUpdated(nextState.searchTerm, this.state.searchTerm)) return true;
    if (_engineHelper.default.checkUpdated(nextState.ArrivalDate, this.state.ArrivalDate)) return true;
    if (_engineHelper.default.checkUpdated(nextState.ArrivalTime, this.state.ArrivalTime)) return true;
    if (_engineHelper.default.checkUpdated(nextState.DepartTime, this.state.DepartTime)) return true;
    if (_engineHelper.default.checkUpdated(nextState.DepartDate, this.state.DepartDate)) return true;
    if (_engineHelper.default.checkUpdated(nextState.savedFlight, this.state.savedFlight)) return true;
    if (_engineHelper.default.checkUpdated(nextState.showFlightModal, this.state.showFlightModal)) return true;
    if (_engineHelper.default.checkUpdated(nextState.terminalField, this.state.terminalField)) return true;
    if (_engineHelper.default.checkUpdated(nextState.terminal, this.state.terminal)) return true;
    if (_engineHelper.default.checkUpdated(nextState.flightTime, this.state.flightTime)) return true;
    if (_engineHelper.default.checkUpdated(nextState.showTerminalDropdown, this.state.showTerminalDropdown)) return true;
    if (_engineHelper.default.checkUpdated(nextState.showFlightSecondChanceModal, this.state.showFlightSecondChanceModal)) return true;
    if (_engineHelper.default.checkUpdated(nextState.flightSecondChanceModalButtonText, this.state.flightSecondChanceModalButtonText)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.agentData, this.props.agentData)) {
      this.getHiddenInputs(nextProps);
      return true;
    }
    if (_engineHelper.default.checkUpdated(nextProps.Location, this.props.Location)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.domainSettings, this.props.domainSettings)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.formSettings, this.props.formSettings)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.ArrivalDate, this.props.ArrivalDate)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.DepartDate, this.props.DepartDate)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.engineSearchField, this.props.engineSearchField)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.hiddenLocation, this.props.hiddenLocation)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.agentSettings, this.props.agentSettings)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.selected, this.props.selected)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.locations, this.props.locations)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.pageName, this.props.pageName)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.showFlight, this.props.showFlight)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.showTerminalsField, this.props.showTerminalsField)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.terminalLink, this.props.terminalLink)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.flightSecondChanceModal, this.props.flightSecondChanceModal)) return true;
    if (_engineHelper.default.checkUpdated(nextProps.promotionCode, this.props.promotionCode)) {
      this.getHiddenInputs(nextProps);
      return true;
    }
    return false;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  componentDidMount() {
    this.getHiddenInputs(this.props);
    this._isMounted = true;
    const {
      useCookies
    } = this.props;
    const {
      ArrivalDate,
      DepartDate
    } = this.getDefaultState();
    let Arrival = null;
    let Depart = null;
    if (!useCookies) {
      // Format for the pickadate cookie is DD/MM/YY yet prop requires to be a date object
      Arrival = ArrivalDate.getDate() + '/' + (ArrivalDate.getMonth() + 1) + '/' + ArrivalDate.getFullYear().toString().substring(2);
      Depart = DepartDate.getDate() + '/' + (DepartDate.getMonth() + 1) + '/' + DepartDate.getFullYear().toString().substring(2);
    }
    _engineHelper.default.setupCalendars({
      form: _helpers.default.$('#parkingEngine'),
      type: 'CarParking',
      cookieKey: 'Engines_',
      callBack: this.externallySetDates,
      tracker: _tracker.default,
      useCookies,
      ArrivalDate: Arrival,
      DepartDate: Depart
    });
  }
  getDefaultState() {
    let {
      location,
      ArrivalTime,
      DepartTime,
      savedFlight,
      flightTime,
      showTerminalDropdown
    } = this.state;
    showTerminalDropdown = showTerminalDropdown || !!_engineHelper.default.engineCookies('terminal');
    const state = {
      location: _engineHelper.default.engineCookies('Location') || location,
      ArrivalTime: _engineHelper.default.engineCookies('ArrivalTime') || ArrivalTime,
      DepartTime: _engineHelper.default.engineCookies('DepartTime') || DepartTime,
      savedFlight: _engineHelper.default.engineCookies('FlightNumber') || savedFlight,
      flightTime: _engineHelper.default.engineCookies('flightTime') || flightTime,
      showTerminalDropdown
    };
    this.setState(state);
    return state;
  }
  getHiddenInputs(props) {
    this.setState({
      hiddenInputs: _engineHelper.default.getHiddenInputs(props)
    });
  }
  locationSelected(location) {
    const {
      dropdowns: {
        locations: {
          locationRedirects = {}
        }
      },
      selected
    } = this.props;
    if (locationRedirects[location] && locationRedirects[location][selected]) return _engineHelper.default.changeUrl(locationRedirects[location][selected]);
    _engineHelper.default.engineCookies('Location', location);
    const {
      terminalField,
      terminal
    } = this.canShowTerminal(location, this.props);
    this.setState({
      location,
      terminalField,
      terminal
    });
  }
  canShowTerminal(location, props) {
    const {
      dropdowns: {
        locations: {
          terminals
        }
      }
    } = props;
    let previousTerminal = _engineHelper.default.engineCookies('terminal');
    if (this.state && this.state.terminal) previousTerminal = this.state.terminal;
    let terminalField = terminals.hasOwnProperty(location);
    let terminal = '';
    _engineHelper.default.engineCookies('terminal', false); // Reset terminal on location change
    if (terminals[location]) {
      const values = Object.keys(terminals[location]).map(item => terminals[location][item]);
      if (_engineHelper.default.inArray(previousTerminal, values)) {
        terminalField = true;
        terminal = previousTerminal;
        _engineHelper.default.engineCookies('terminal', terminal); // Reset terminal on location change
      }
    }
    return {
      terminalField,
      terminal
    };
  }
  flightFieldInteraction() {
    _helpers.default.setCookie('flight_fields_changed_by_user', 1);
  }
  externallySetDates(date, type) {
    if (!this._isMounted) return;
    let {
      ArrivalDate,
      DepartDate
    } = this.state;
    if (type === 'ArrivalDate') ArrivalDate = date;
    if (type === 'DepartDate') DepartDate = date;
    this.setState({
      ArrivalDate,
      DepartDate
    });
  }
  dateFocused() {
    this.setState({
      datesTouched: true
    });
  }
  searchAllClicked(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!this.handleSubmit(e)) return;
    this.setState({
      searchTerm: ''
    }, () => {
      this.refs.parkingEngine.submit();
    });
  }
  searchProductClicked(searchTerm) {
    this.setState({
      searchTerm: searchTerm
    }, () => {
      if (this.state.datesTouched) {
        this.refs.parkingEngine.submit();
      } else if (typeof window !== 'undefined' && typeof $ !== 'undefined') {
        this.setState({
          datesTouched: true
        }, () => {
          const ua = window.navigator.userAgent;
          const msie = ua.indexOf('MSIE ');
          const trident = ua.indexOf('Trident/');
          // IE11 or less
          if (msie > 0 || trident > 0) {
            $('.arrivalPicker').click();
          } else {
            $('.arrivalPicker').focus().pickadate('open');
          }
        });
      }
    });
  }
  changedFlight(flight) {
    if (!flight || !flight.departure) {
      this.terminalSelect('terminal', '');
      return;
    }
    const {
      terminal
    } = this.state;
    if (flight.departure.terminal === terminal) return;
    this.terminalSelect('terminal', flight.departure.terminal);
    this.showTerminalField();
  }
  changedFlightFromModal(flight) {
    const {
      id
    } = this.props;
    this.changedFlight(flight);
    if (!flight || !flight.flight || !flight.flight.code) {
      this.terminalSelect('terminal', '');
      return;
    }
    _helpers.default.$(`#${id} input[name=flight_number]`).value = flight.flight.code;
    this.setState({
      flightSecondChanceModalButtonText: 'Search'
    });
  }
  terminalSelect(name, value) {
    if (value === 'Show all') value = '';
    _engineHelper.default.engineCookies(name, value);
    this.setState({
      terminal: value
    });
  }
  terminalFormGroup() {
    const {
      dropdowns: {
        locations
      },
      dropdowns: {
        locations: {
          terminals
        }
      },
      translations
    } = this.props;
    const {
      location,
      terminal,
      terminalField
    } = this.state;
    if (!terminalField || !terminals) return false;
    const {
      terminalLabel
    } = translations;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group terminalDropdown"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "terminalSelectCp"
    }, terminalLabel), /*#__PURE__*/_react.default.createElement(_terminalDropdown.default, {
      id: "terminalSelectCp",
      onSelect: this.terminalSelect,
      activeTerminal: terminal,
      name: "terminal",
      locations: locations,
      location: location
    }));
  }
  showTerminals() {
    const {
      dropdowns: {
        locations
      }
    } = this.props;
    const {
      location
    } = this.state;
    return locations.terminals && locations.terminals[location];
  }
  saveTime(name, value) {
    const newState = {};
    newState[name] = value;
    _engineHelper.default.engineCookies(name, value);
    this.setState(newState);
    if (name === 'flightTime') {
      this.flightFieldInteraction();
    }
    if (name === 'ArrivalTime' && this.props.showFlight) {
      if (value.slice(-2) !== '00') {
        value = Number(value.slice(0, 2)) + 1 + '00';
      }
      this.saveTime('flightTime', this.adjustFlightDefaultTime(value));
    }
    if (name === 'ArrivalTime' && this.state.terminal) {
      if (!_reactDom.default.findDOMNode(this).querySelector('#flightSearch input')) return;
      _reactDom.default.findDOMNode(this).querySelector('#flightSearch input').focus();
    }
  }
  adjustFlightDefaultTime(value) {
    let newDate = Number(value) + 200;
    if (newDate > 2359) newDate -= 2400;
    if (!newDate) return '0000';
    return _dateHelper.default.pad(newDate, 4);
  }
  updateFlight(response) {
    const {
      id
    } = this.props;
    if (response) _helpers.default.$('#' + id).submit();
    this.setState({
      showFlightModal: false
    });
  }
  showTerminalField(e) {
    if (e) e.preventDefault();
    this.setState({
      showTerminalDropdown: true
    });
  }
  trackSearch() {
    const {
      agentData: {
        agent
      }
    } = this.props;
    const {
      location,
      ArrivalTime,
      ArrivalDate,
      DepartDate,
      DepartTime
    } = this.state;
    const params = {
      action: 'Create',
      search: {
        search_id: _engineHelper.default.uuid(),
        agent,
        from: _engineHelper.default.adjustTrackingDates(ArrivalDate, ArrivalTime),
        to: _engineHelper.default.adjustTrackingDates(DepartDate, DepartTime),
        product_code: null,
        product_name: null,
        product_type: 'carpark',
        carpark: {
          location: null,
          location_code: location,
          destination: null,
          destination_code: null
        }
      }
    };
    const {
      state: {
        chosenFlight = {}
      }
    } = this.flightInput && this.flightInput.flightSearch ? this.flightInput.flightSearch : {
      state: {}
    };
    if (chosenFlight && chosenFlight.flight && chosenFlight.flight.code) {
      const {
        arrival = {},
        departure = {},
        flight = {}
      } = chosenFlight;
      const departFrom = _engineHelper.default.adjustTrackingDates(departure.date, departure.time);
      const departTo = _engineHelper.default.adjustTrackingDates(arrival.date, arrival.time);
      params.search.carpark.location = departure.city;
      params.search.carpark.destination_code = arrival.airport_iata;
      params.search.carpark.destination = arrival.city;
      params.flight = {
        code: flight.code,
        departure: {
          datetime: departFrom,
          airport_iata: departure.airport_iata,
          city: departure.city,
          terminal: departure.terminal || null
        },
        arrival: {
          datetime: departTo,
          airport_iata: arrival.airport_iata,
          city: arrival.city,
          terminal: arrival.terminal || null
        }
      };
    }
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + 90 * 60 * 1000);
    _helpers.default.setCookie('search_id', params.search.search_id, expiry, '.holidayextras.co.uk');
    _tracker.default.track(null, params, 'search');
  }
  forceEngineSubmit() {
    const {
      id
    } = this.props;
    _helpers.default.$('#' + id).submit();
  }
  formSubmit(e) {
    const {
      submitHandler
    } = this.props;
    this.trackSearch();
    if (typeof submitHandler === 'function') return submitHandler(e);
    return true;
  }
  render() {
    const {
      settings,
      domainSettings,
      hiddenLocation,
      selected,
      formSettings,
      dropdowns: {
        locations
      },
      showFlight,
      id,
      showTerminalsField,
      terminalLink,
      isHomepage,
      pageName,
      showPromoCode,
      translations,
      agentData,
      labels,
      port
    } = this.props;
    const {
      hiddenInputs,
      location,
      searchTerm,
      ArrivalTime,
      DepartTime,
      ArrivalDate,
      DepartDate,
      savedFlight,
      showFlightModal,
      terminal,
      flightTime,
      showTerminalDropdown
    } = this.state;
    const {
      parkingFromLabel,
      parkingToLongLabel,
      parkingToShortLabel,
      flightTimeLabel,
      terminalLinkText,
      searchButtonText,
      searchButtonLoadingText,
      flightInput
    } = translations;
    const {
      agent,
      typeRID,
      groupCode
    } = agentData;
    const resetSubmitButtonText = !showFlightModal;
    let arrivalDateFormatted = _dateHelper.default.formatDateToDddMMyy(ArrivalDate, domainSettings.language.toUpperCase());
    arrivalDateFormatted = arrivalDateFormatted.slice(0, -4) + arrivalDateFormatted.slice(-2);
    let departDateFormatted = _dateHelper.default.formatDateToDddMMyy(DepartDate, domainSettings.language.toUpperCase());
    departDateFormatted = departDateFormatted.slice(0, -4) + departDateFormatted.slice(-2);
    const terminals = this.showTerminals();
    domainSettings.domainScheme = domainSettings.domainScheme ? domainSettings.domainScheme : 'http';
    const defaultInputs = {
      agentgroup: groupCode,
      channel: typeRID,
      agent: agent,
      product: 'cp',
      selectProduct: 'cp',
      request: '1',
      Referer: domainSettings.domainScheme + '://' + domainSettings.domain + '/' + (!isHomepage && pageName ? pageName + '.html' : ''),
      domain: typeRID === 'R' ? domainSettings.agentDomain : domainSettings.domain,
      rule_set: formSettings.ruleset,
      lang: formSettings.language || 'en',
      System: formSettings.System || ''
    };
    const engineClass = (0, _classnames.default)({
      'clearfix': true,
      'hxEmbed': true,
      'panel': true,
      'panel-body': true,
      'terminal': showTerminalsField && terminals && !port,
      'terminalBelow': showTerminalsField && terminalLink && terminals && !port,
      'flightDropdown': showFlight,
      'flight': showFlight,
      'hidden': selected !== 'cp' && selected !== 'portparking'
    });
    const terminalFormGroup = this.terminalFormGroup();
    let flightDate = ArrivalDate;
    if (Number(flightTime) < Number(ArrivalTime)) {
      const newFlightDate = _dateHelper.default.alterDateByNumberOfDays(new Date(flightDate), 1);
      flightDate = newFlightDate;
    }
    const locationValues = port ? locations.port : locations.carParking;
    const locationLabel = port ? labels.locationLabel : translations.locationLabel;
    return /*#__PURE__*/_react.default.createElement("form", {
      ref: c => {
        this.parkingEngine = c;
      },
      id: id,
      acceptCharset: "UTF-8",
      action: formSettings.parkingAction,
      className: engineClass,
      method: formSettings.method,
      onSubmit: this.formSubmit
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "clearfix list-unstyled"
    }, !hiddenLocation && /*#__PURE__*/_react.default.createElement("li", {
      className: "col-md-2 locationSelect"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "locationInputCp"
    }, locationLabel), /*#__PURE__*/_react.default.createElement(_locationDropdown.default, {
      activeLocation: location,
      id: "locationInputCp",
      locations: locationValues,
      onSelect: this.locationSelected,
      port: port
    }), !showTerminalDropdown && terminals && showFlight && !port && /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      className: "pull-right small",
      onClick: this.showTerminalField
    }, terminalLinkText)), terminalLink && showTerminalDropdown && terminalFormGroup), hiddenLocation && /*#__PURE__*/_react.default.createElement("input", {
      name: "Location",
      type: "hidden",
      className: "l",
      value: hiddenLocation,
      "data-track-name": "location"
    }), !terminalLink && showTerminalDropdown && terminalFormGroup, /*#__PURE__*/_react.default.createElement("li", {
      className: "col-md-3 col-xs-9 calendar"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "ArrivalSelectCp",
      dangerouslySetInnerHTML: {
        __html: parkingFromLabel
      }
    }), /*#__PURE__*/_react.default.createElement("input", {
      className: "picker__input arrivalPicker form-control",
      id: "ArrivalSelectCp",
      name: "Arrival",
      type: "text",
      defaultValue: arrivalDateFormatted,
      readOnly: true,
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-readonly": "false",
      onFocus: this.dateFocused
    })), /*#__PURE__*/_react.default.createElement("li", {
      className: "col-md-1 col-xs-3 timeSelect"
    }, /*#__PURE__*/_react.default.createElement(_timesDropdown.default, {
      className: "time col-xs-4 pull-right",
      onSelect: this.saveTime,
      name: "ArrivalTime",
      id: "ArrivalTimeCp",
      activeTime: ArrivalTime,
      hiddenLabel: true
    })), showFlight && !port && /*#__PURE__*/_react.default.createElement("li", {
      className: "col-md-1 col-xs-3 flightTime"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "FlightTimeCp"
    }, flightTimeLabel), /*#__PURE__*/_react.default.createElement(_timesDropdown.default, {
      roundTimes: true,
      loopOver: true,
      betweenTimes: true,
      hourSplit: 1,
      onSelect: this.saveTime,
      name: "flightTime",
      id: "FlightTimeCp",
      showMidnight: true,
      startingTime: ArrivalTime,
      activeTime: flightTime
    })), showFlight && !port && /*#__PURE__*/_react.default.createElement(_flightInput.default, {
      ref: c => {
        this.flightInput = c;
      },
      id: "flightInputCP",
      name: "flight_number",
      cookieName: "FlightNumber",
      activeFlight: savedFlight,
      location: hiddenLocation || location,
      departure: flightDate,
      departureTime: flightTime,
      departureTimeMax: 100,
      departureTimeMin: 0,
      terminal: terminal,
      tip: "",
      showFlightDropdown: true,
      scrollResults: true,
      placeHolder: "Choose flight",
      onChange: this.changedFlight,
      flightInput: flightInput,
      arrivalDate: ArrivalDate,
      flightTime: flightTime,
      startTime: ArrivalTime,
      flightFieldInteraction: this.flightFieldInteraction,
      autoFocus: true,
      formSettings: formSettings
    }), /*#__PURE__*/_react.default.createElement("li", {
      className: "col-md-3 col-xs-9 calendar"
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "DepartSelectCp",
      className: "hidden-xs hidden-sm hidden-md"
    }, parkingToLongLabel), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "DepartSelectCp",
      className: "hidden visible-xs-inline-block visible-sm-inline-block visible-md-inline-block"
    }, parkingToShortLabel), /*#__PURE__*/_react.default.createElement("input", {
      id: "DepartSelectCp",
      className: "picker__input departPicker form-control",
      name: "Depart",
      type: "text",
      defaultValue: departDateFormatted,
      readOnly: true,
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-readonly": "false",
      onFocus: this.dateFocused
    })), /*#__PURE__*/_react.default.createElement("li", {
      className: "col-md-1 col-xs-3 timeSelect"
    }, /*#__PURE__*/_react.default.createElement(_timesDropdown.default, {
      className: "time col-xs-4 pull-right",
      id: "DepartTimeCp",
      onSelect: this.saveTime,
      name: "DepartTime",
      activeTime: DepartTime,
      hiddenLabel: true
    })), /*#__PURE__*/_react.default.createElement("li", {
      className: "submitContainer col-md-2"
    }, /*#__PURE__*/_react.default.createElement(_wowcherPromo.default, {
      id: "promoFieldCP",
      agent: agent,
      showPromoCode: showPromoCode,
      settings: settings
    }), /*#__PURE__*/_react.default.createElement(_searchButton.default, {
      searchText: searchButtonText,
      pleaseWaitText: searchButtonLoadingText,
      reset: resetSubmitButtonText
    }))), /*#__PURE__*/_react.default.createElement(_hiddenInputs.default, {
      inputs: defaultInputs
    }), searchTerm.length > 0 && /*#__PURE__*/_react.default.createElement("input", {
      name: "search",
      type: "hidden",
      value: searchTerm
    }), /*#__PURE__*/_react.default.createElement(_hiddenInputs.default, {
      inputs: hiddenInputs
    }));
  }
}
ParkingEngine.propTypes = {
  settings: _propTypes.object,
  Location: _propTypes.string,
  domainSettings: _propTypes.object,
  formSettings: _propTypes.object,
  ArrivalDate: (0, _propTypes.instanceOf)(Date),
  DepartDate: (0, _propTypes.instanceOf)(Date),
  engineSearchField: _propTypes.string,
  hiddenLocation: _propTypes.string,
  agentSettings: _propTypes.object,
  selected: _propTypes.string,
  dropdowns: _propTypes.object,
  pageName: _propTypes.string,
  showFlight: _propTypes.bool,
  showTerminalsField: _propTypes.bool,
  terminalLink: _propTypes.bool,
  isHomepage: _propTypes.bool,
  showPromoCode: _propTypes.bool,
  translations: _propTypes.object,
  port: _propTypes.bool,
  submitHandler: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.bool])
};
ParkingEngine.defaultProps = {
  hiddenLocation: '',
  engineSearchField: '',
  dropdowns: {},
  formSettings: {},
  ArrivalDate: _dateHelper.default.alterDateByNumberOfDays(new Date(), 1),
  DepartDate: _dateHelper.default.alterDateByNumberOfDays(new Date(), 8),
  selected: 'cp',
  showFlight: false,
  id: 'parkingEngine',
  showTerminalsField: false,
  terminalLink: false,
  isHomepage: false,
  priceForecastTool: false,
  showPromoCode: false,
  agentData: {},
  port: false,
  pageName: '',
  submitHandler: false
};
var _default = exports.default = ParkingEngine;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/forms/parking-engine.js
// module id = 739
// module chunks = 119